<template>
  <div class="cart-addons">
    <products-expand visible-on-load
                     :group-title="$t('checkout.cartOverview.chooseAddonsTitle')"
                     class="addons-expand">
      <img slot="icon" src="/assets/images/icon-info-more.svg" alt="">
      <div class="addons-body">
        <ec-carousel :carousel-options="sliderOptions">
          <ec-carousel-slide v-for="addon in $props.addonList"
                             :key="addon.code">
            <addon-single :addon-name="addon.name"
                          :addon-price="addon.price"
                          :addon-features="addon.productSpecCharacteristicValues"
                          @select-addon="addAddonToCart(addon.code)"/>
          </ec-carousel-slide>
        </ec-carousel>
      </div>
    </products-expand>
  </div>
</template>

<script>
import ProductsExpand from '../../common/products-expand'
import { EcCarousel, EcCarouselSlide } from '../../base/mini-carousel'
import AddonSingle from '../../common/addon-single'
import { addServiceToCart } from '../../../api/cart'
import { getCookie } from '../../../utils/cookieController'

export default {
  name: 'checkout-cart-addons',
  components: { AddonSingle, EcCarouselSlide, EcCarousel, ProductsExpand },
  data () {
    return {
      sliderOptions: Object.freeze({
        spaceBetween: 4,
        breakpoints: {
          320: {
            slidesPerView: 1
          },
          768: {
            slidesPerView: 2
          },
          1366: {
            slidesPerView: 3
          }
        }
      })
    }
  },
  props: {
    addonList: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    addAddonToCart (addonCode) {
      const cartId = getCookie('guid')
      const dataToSend = {
        cartId: cartId,
        code: addonCode,
        fromCheckout: true,
        replace: false
      }
      this.$loader.show()
      addServiceToCart(dataToSend)
        .then(response => {
          this.$emit('refresh-cart', true)
        })
        .catch(e => {
          console.log('error', e)
        })
        .finally(() => {
          this.$loader.hide()
        })
    }
  }
}
</script>

<style scoped lang="scss">
.cart-addons {
  margin-bottom: 4rem;
}

.addons-body {
  margin-top: 4px;
  max-width: 100%;
}

.addons-expand /deep/ .product-expand-header {
  width: 100%;
  margin: auto;

  @media (map_get($breakpoints, sm)) {
    max-width: calc(100% - 6.4rem);
  }

  @media (map_get($breakpoints, md)) {
    max-width: 100%;
  }
}
</style>
